<template>
  <div>
    <v-dialog
      persistent
      v-model="value"
      scrollable
      max-width="350px"
    >
      <v-card>
        <v-container
          fluid
          style="margin: 0px; padding: 0px"
        >
          <v-layout
            row
            class="separatorNotice"
          > 
            <h2 class="font-weight-regular white--text separatorTittle">
              Crear salón
            </h2>
          </v-layout> 
          <v-layout
            wrap
            row
          >
            <v-flex
              xs12
              class="centerContent"
              style="text-align: center; padding-left: 20px; padding-right: 20px"
            >
              <v-text-field
                label="Nombre del salón"
                v-model="$v.dataForm.classroomName.$model"
                outline
                :error-messages="titleErrors"
                style=" margin-top: 25px;"
              />
            </v-flex>
          </v-layout>
          <v-layout
            wrap
            row
            style="padding: 10px"
          >
            <v-flex
              xs6
              class="centerContent"
            >
              <v-btn
                small
                color="primary"
                @click="close"
                :disabled="toast.loading"
              >
                Cancelar
              </v-btn>
            </v-flex>

            <v-flex
              xs6
              class="centerContent"
            >
              <v-btn
                small
                color="primary"
                @click="save"
                :disabled="toast.loading"
              >
                Confirmar
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <loading
      text="Trabajando..."
      v-model="toast.loading"
    />
    <success
      v-model="toast.success"
      text="Operación Exitosa"
    />
    <error
      v-model="toast.failed"
      :text="messageError"
    />
  </div>
</template>

<script>

import 'vue2-timepicker/dist/VueTimepicker.css';
import { required } from "vuelidate/lib/validators";
import { getMessageError, isEmptyOrNull } from "../../../plugins/GeneralMethods"
import Error from '../../Dialogs/Error.vue';
import Loading from '../../Dialogs/Loading.vue';
import Success from '../../Dialogs/Success.vue';
export default {
    components: {
        Success,
        Error,
        Loading
    },
    props: ["value", "roomEdit"],
    validations: {
      dataForm: {
          classroomName: { required }
      }
    },
    data: () => ({
      dataForm: {
        classroomName: ""
      },
      toast: {
        success: false,
        failed: false,
        loading: false
      },
      messageError: "Ups, ocurrió un error"
    }),
    watch: {
      roomEdit(){
        this.dataForm.classroomName = this.roomEdit.classroomName
      }
    },
    methods: {
        close() {
          this.$emit("input", false)
          this.$v.dataForm.classroomName.$reset()
        },
        save(){
          this.$v.dataForm.$touch();
          if(!this.$v.dataForm.$invalid){
            this.toast.loading = true
            const objc = this.dataForm
            objc.classroomId = undefined
            if(isEmptyOrNull(this.roomEdit.classroomName)){
              this.$store
                .dispatch("classRoom/createClassroom", objc)
                .then(response => {
                  this.toast.success = true
                  this.rooms = response.data.entity
                  this.close()
                  this.$emit('close')
                  this.toast.loading = false
                })
                .catch(response => {
                    this.messageError = getMessageError(response.data)
                    this.toast.loading = false
                    this.toast.failed = true
                    this.rooms = []
                });
            }else{
              objc.classroomId = this.roomEdit.classroomId
              this.$store
                .dispatch("classRoom/editClassroom", objc)
                .then(response => {
                  this.toast.success = true
                  this.rooms = response.data.entity
                  this.close()
                  this.$emit('close')
                  this.toast.loading = false
                })
                .catch(response => {
                    this.messageError = getMessageError(response.data) 
                    this.toast.failed = true
                    this.toast.loading = false
                    this.rooms = []
                });
            }
            
          }
        }
    },
    computed: {
      titleErrors() {
        const errors = []
        if (! this.$v.dataForm.classroomName.$dirty) return errors;
        !this.$v.dataForm.classroomName.required && errors.push("El nombre del salón es obligatorio");
        return errors
      }
    }

};
</script>

<style >

.separatorNotice {
  background-color: #512e6f;
  height: 60px;
}

.message {
    font-size: large;
    color: black;

}
</style>